export default __webpack_public_path__ + "static/media/thedolist.7f0c8a1e.png";